import { getFiatSummaryApi } from '@/api/fiatApi';
import { QUERY_REFETCH_INTERVAL } from '@/lib/constants';
import { FiatVolumes } from '@/state/fiat/fiatTypes';
import { CURRENCIES } from '@/lib/types/generalTypes';

export const FIAT_VOLUMES_QUERY_KEY = ['fiatVolumes'] as const;

export const fiatVolumesQuery = {
    queryKey: FIAT_VOLUMES_QUERY_KEY,
    queryFn: async (): Promise<FiatVolumes> => {
        const { data } = await getFiatSummaryApi();
        return {
            ...data,
            currency: data.fiatNativeCurrency || CURRENCIES.USD,
        };
    },
    staleTime: QUERY_REFETCH_INTERVAL,
};
